import { groupBy } from "utils/groupData";
import {
  EDIT_MEMBER,
  MEMBERS_LIST,
  TEAM_MEMBERS,
  ADD_MEMBER,
  BAMBOOHR_EMPLOYEES,
  SCHEDULES,
  EMAILS,
  ROLES,
  HAS_ACCOUNT,
} from "../actions/types";

const initialState = [];

function initState(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case MEMBERS_LIST:
      return {
        ...state,
        list: payload,
        groups: groupBy(payload, "team_id__name"),
      };

    case TEAM_MEMBERS:
      return {
        ...state,
        team: payload.filter(({ is_active }) => is_active),
        allTeam: payload,
        scheduleGroup: groupBy(payload, "schedule"),
      };

    case EDIT_MEMBER:
      return {
        ...state,
        team: state.team.map((member) =>
          member.id === payload.id ? { ...member, ...payload } : member
        ),
      };

    case ADD_MEMBER:
      return { ...state, payload, memberId: payload.id };

    case BAMBOOHR_EMPLOYEES:
      return { ...state, bamboohrEmployees: payload };

    case SCHEDULES:
      return { ...state, schedules: payload };

    case EMAILS:
      return { ...state, emails: payload };

    case ROLES:
      return { ...state, roles: payload };

    case HAS_ACCOUNT:
      return { ...state, hasAccount: payload };

    default:
      return state;
  }
}

export default initState;
